var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreServiceBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 1536,
    viewBox: "0 0 345 1536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3800_4879",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 402,
    height: 1536
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1536H402V0H0V1536Z",
    fill: "#141414"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3800_4879)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3800_4879)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.52 514.257C445.52 281.05 381.711 91.999 303 91.999C224.288 91.999 160.48 281.05 160.48 514.257C160.48 747.464 224.288 936.516 303 936.516C381.711 936.516 445.52 747.464 445.52 514.257Z",
    fill: "#8D19DA"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3800_4879",
    x: -69.5198,
    y: -138,
    width: 745.039,
    height: 1304.52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 115,
    result: "effect1_foregroundBlur_3800_4879"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreServiceBg);
export default __webpack_public_path__ + "static/media/moreServiceBg.8ef4b2d81f8739722bf56810c6047ce1.svg";
export { ForwardRef as ReactComponent };